import React, {useEffect} from 'react'
import Fade from 'react-reveal/Fade'
import Zoom from 'react-reveal/Zoom'

function BuildingMaterials() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <div>
        <div>
          <Zoom>
        <div className="m-auto text-center"><h3 className="text-red-red1 font-extrabold text-3xl pt-10">OUR<br />Electricity</h3> <hr className="bg-red-red1 h-1 w-28 rounded-md m-auto" /></div>
      </Zoom>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-10 gri">
        <Fade bottom>
        <div className="h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./wire.jpg' alt='carrier' className="h-2/3 w-2/3 items-center m-auto"/>
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2"> wire <br />(all sizes)</h3>
          </div>
          </Fade>
          <Fade bottom>
        <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./3 ping socket.jpeg' alt='wood-oli' className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">3 ping & double ping<br />sockets</h3>
          </div>
          </Fade>
          <Fade bottom>
        <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Triple switch .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Single, double & triple  <br />switch</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Cooker switch .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Cooker<br />switch</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./TV sockets .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">TV & tell <br />sockets</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Hager breaker .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Hager breaker <br />(all types)</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Metal box switch.jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Metal box<br />(single & double)</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./ceiling lamp .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">ceiling<br />lamp</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Led lamps .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Led lamps <br />(all types)</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Tell wires .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">TV & Tell <br />wires</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Spot light.jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Spot<br />light</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Joint box.jpg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Joint box <br />(all sizes)</h3>
          </div>
          </Fade>
          <Fade bottom>
          <div className=" h-72 my-6 bg-white shadow-xl rounded-md w-11/12 m-auto py-10">
          <img src='./Panel board .jpeg' alt='carrier'className="h-2/3 w-2/3 items-center m-auto" />
          <h3 className="text-white pt-3 font-extrabold text-center h-20 w-full bg-red-red2">Panel board <br />(all types)</h3>
          </div>
          </Fade>          
      </div>
        </div>
    </div>
  )
}

export default BuildingMaterials